import { CommonModule } from '@angular/common';
import { Component, input, Input, signal } from '@angular/core';

@Component({
  selector: 'app-loading-modal',
  imports: [CommonModule],
  templateUrl: './loading-modal.html',
  styleUrl: './loading-modal.css',
})
export class LoadingModal {
  isLoading = input<boolean>(false);
  isSuccess = input<boolean>(false);
  isError = input<boolean>(false);
  loadingTitle = input<string>('Sending...');
  loadingMessage = input<string>('Please wait.');
  successTitle = input<string>('✓ Success!');
  successMessage = input<string>('Operation completed successfully.');
  errorTitle = input<string>('✗ Error');
  errorMessage = input<string>('An error occurred. Please try again.');
}
